import { useState, useEffect } from "react";
import WaitingList from "../components/waitingList";

export default function CRM() {
  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");

    const fetch_data = async () => {
      try {
        setLoading(true);
        const res = await fetch("https://zaichat.net/api/get_chats", {
          method: "GET",
          headers: {
            auth: `Bearer ${token}`,
          },
        });

        if (!res.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await res.json();
        console.log(data.data);
        setData(data.data);
        setError(null);
      } catch (err) {
        setError(err.message);
        console.error("Error fetching data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetch_data();
  }, []);

  // Filter data with check if data exists
  console.log(data);
  const filteredData = data.length > 0
    ? data.filter((item) => {
        const searchLower = search.toLowerCase();
        const itemName = item.name || "";
        const itemNumber = item.number || "";
        const itemStatus = item.status || "";

        return (
          item.id.toString().includes(searchLower) ||
          itemName.toLowerCase().includes(searchLower) ||
          itemNumber.toLowerCase().includes(searchLower) ||
          itemStatus.toLowerCase().includes(searchLower)
        );
      })
    : [];

  // Get status badge color
  const getStatusColor = (status) => {
    switch (status) {
      case "Customer":
        return "bg-green-100 text-green-700 border-green-300";
      case "Prospect":
        return "bg-blue-100 text-blue-700 border-blue-300";
      case "Lead":
        return "bg-orange-100 text-orange-700 border-orange-300";
      case "Inactive":
        return "bg-gray-100 text-gray-700 border-gray-300";
      default:
        return "bg-gray-100 text-gray-700 border-gray-300";
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-amber-50 text-gray-800 py-10 px-6 md:px-10 transition-all duration-500">
      {/* Header */}
      <div className="bg-gradient-to-r from-[#1e3c72] to-[#ff7e00] text-white rounded-2xl p-8 shadow-lg mb-8">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div>
            <h1 className="text-3xl font-extrabold mb-2 flex items-center gap-2">
              <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4" />
              </svg>
              CRM Dashboard
            </h1>
            <p className="text-white/90 text-sm">
              Manage and view your customer relationships — leads, prospects, and customers
            </p>
          </div>

          {/* Search Bar */}
          <div className="flex items-center gap-2 border border-white/40 rounded-lg px-4 py-2.5 bg-white/10 backdrop-blur-sm min-w-[300px]">
            <svg className="w-5 h-5 text-white/80" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
            <input
              type="text"
              placeholder="Search by name, number, or status..."
              className="text-sm focus:outline-none bg-transparent text-white placeholder-white/70 w-full"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-6">
          <div className="bg-white/20 backdrop-blur-sm rounded-lg p-4">
            <div className="text-white/80 text-xs font-medium mb-1">Total Contacts</div>
            <div className="text-2xl font-bold">{data.length}</div>
          </div>
          <div className="bg-white/20 backdrop-blur-sm rounded-lg p-4">
            <div className="text-white/80 text-xs font-medium mb-1">Customers</div>
            <div className="text-2xl font-bold">{data.length > 0 ? data.filter(d => d.status === "Customer").length : 0}</div>
          </div>
          <div className="bg-white/20 backdrop-blur-sm rounded-lg p-4">
            <div className="text-white/80 text-xs font-medium mb-1">Prospects</div>
            <div className="text-2xl font-bold">{data.length > 0 ? data.filter(d => d.status === "Prospect").length : 0}</div>
          </div>
          <div className="bg-white/20 backdrop-blur-sm rounded-lg p-4">
            <div className="text-white/80 text-xs font-medium mb-1">Leads</div>
            <div className="text-2xl font-bold">{data.length > 0 ? data.filter(d => d.status === "Lead").length : 0}</div>
          </div>
        </div>
      </div>

      {/* Table Section */}
      <div className="bg-white rounded-2xl shadow-lg border border-orange-200 p-6 md:p-8">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-2">
            <svg className="w-6 h-6 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <h2 className="text-xl font-bold text-gray-800">Contact Records</h2>
          </div>
          <p className="text-sm text-gray-500">
            Showing {filteredData.length} of {data.length} entries
          </p>
        </div>

        {/* Loading / Error / Table */}
        {loading ? (
          <div className="text-center py-16">
            <svg className="w-12 h-12 text-orange-500 mx-auto mb-4 animate-spin" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <p className="text-gray-500">Loading contacts...</p>
          </div>
        ) : error ? (
          <div className="text-center py-16">
            <svg className="w-12 h-12 text-red-500 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <p className="text-red-600 font-medium">{error}</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-orange-50 text-gray-700 font-semibold">
                  <th className="border border-orange-200 p-3 text-left">ID</th>
                  <th className="border border-orange-200 p-3 text-left">Name</th>
                  <th className="border border-orange-200 p-3 text-left">Phone Number</th>
                  <th className="border border-orange-200 p-3 text-center">Status</th>
                  <th className="border border-orange-200 p-3 text-center">Messages</th>
                  <th className="border border-orange-200 p-3 text-left">Last Activity</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center py-12 text-gray-500">
                      <div className="flex flex-col items-center justify-center gap-3">
                        <svg className="w-16 h-16 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <p className="font-medium">No contacts found</p>
                        <p className="text-sm text-gray-400">Try adjusting your search criteria</p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  filteredData.map((item) => (
                    <tr key={item.id} className="hover:bg-orange-50 transition-colors">
                      <td className="border border-orange-100 p-3 font-medium text-gray-700">#{item.id}</td>
                      <td className="border border-orange-100 p-3">
                        <div className="flex items-center gap-2">
                          <div className="w-8 h-8 rounded-full bg-orange-100 flex items-center justify-center text-orange-600 font-semibold text-sm">
                            {item.name ? item.name.charAt(0).toUpperCase() : "?"}
                          </div>
                          <span className="font-medium text-gray-800">
                            {item.name || <span className="text-gray-400 italic">Unknown</span>}
                          </span>
                        </div>
                      </td>

                      {/* Phone Number with WhatsApp */}
                      <td className="border border-orange-100 p-3 text-gray-600">
                        {item.number ? (
                          <div className="flex items-center gap-2">
                            <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                            </svg>
                            <a
                              href={`https://wa.me/${item.number}?text=Start`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-green-600 hover:text-green-800 hover:underline transition-all"
                            >
                              +{item.number}
                            </a>
                          </div>
                        ) : (
                          <span className="text-gray-400 italic">No number</span>
                        )}
                      </td>

                      <td className="border border-orange-100 p-3 text-center">
                        <span className={`inline-block px-3 py-1 rounded-full text-xs font-semibold border ${getStatusColor(item.status)}`}>
                          {item.status}
                        </span>
                      </td>
                      <td className="border border-orange-100 p-3 text-center">
                        <div className="flex items-center justify-center gap-1">
                          <svg className="w-4 h-4 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
                          </svg>
                          <span className="font-semibold text-gray-700">{item.message_count}</span>
                        </div>
                      </td>
                      <td className="border border-orange-100 p-3 text-gray-600 text-sm">
                        {item.last_activity_at === "Never" ? (
                          <span className="text-gray-400 italic">No activity</span>
                        ) : (
                          <div className="flex items-center gap-2">
                            <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            {item.last_activity_at}
                          </div>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <WaitingList />
    </div>
  );
}
